(function () {
  function init(sectionEl) {
    if (!sectionEl) return;
    sectionEl.querySelectorAll("[data-f4u-card]").forEach((card) => {
      card.style.cursor = "pointer";
    });

    sectionEl.querySelectorAll("img").forEach((img) => {
      img.setAttribute("draggable", "false");
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".f4u").forEach(init);
  });

  document.addEventListener("shopify:section:load", (e) => {
    const sectionEl = document.getElementById(`f4u-${e.detail.sectionId}`);
    init(sectionEl);
  });
})();
